export default "__VITE_ASSET__DLkmjCf8__"